"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Position = exports.Option = exports.Menu = exports.DropdownWrapper = exports.DropdownButtonWrapper = exports.DropdownButtonContainer = exports.DiagonalLine = exports.CurrentSelection = exports.Color = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styles = require("../../shared/styles");
var Position = exports.Position = _styledComponents.default.div.withConfig({
  displayName: "Dropdownstyled__Position",
  componentId: "sc-ms0xtq-0"
})(["position:relative;height:", ";width:", ";"], function (_ref) {
  var size = _ref.size;
  return _styles.height[size];
}, function (_ref2) {
  var fit = _ref2.fit;
  return fit ? '100%' : '200px';
});
var DropdownWrapper = exports.DropdownWrapper = _styledComponents.default.div.withConfig({
  displayName: "Dropdownstyled__DropdownWrapper",
  componentId: "sc-ms0xtq-1"
})(["display:inline-flex;align-items:center;justify-content:space-between;gap:", ";box-sizing:border-box;cursor:pointer;height:", ";width:", ";padding:", " ", ";border:1px solid ", ";border-radius:", ";background:", ";", " &:hover{border:1px solid ", ";}", " svg{path{fill:", ";}}"], _styles.spacing.xs, function (_ref3) {
  var size = _ref3.size;
  return _styles.height[size];
}, function (_ref4) {
  var fit = _ref4.fit;
  return fit ? '100%' : '200px';
}, _styles.spacing.xs, _styles.spacing.s, function (_ref5) {
  var error = _ref5.error;
  return error ? _styles.colors.border.error.default : _styles.colors.border.primary.default;
}, _styles.borderRadius.s, function (_ref6) {
  var error = _ref6.error;
  return error ? _styles.colors.background.error : _styles.colors.background.primary;
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? (0, _styledComponents.css)(["pointer-events:none;color:", ";background-color:", ";border-color:", ";"], _styles.colors.text.secondary, _styles.colors.background.disabled, _styles.colors.border.disabled) : (0, _styledComponents.css)([""]);
}, function (_ref8) {
  var expanded = _ref8.expanded,
    error = _ref8.error;
  return expanded ? _styles.colors.border.focus : error ? _styles.colors.border.error.hover : _styles.colors.border.primary.hover;
}, function (_ref9) {
  var expanded = _ref9.expanded;
  return expanded && (0, _styledComponents.css)(["border:1px solid ", ";outline:4px solid ", ";"], _styles.colors.border.focus, _styles.colors.outline.focus);
}, function (_ref10) {
  var disabled = _ref10.disabled;
  return disabled ? _styles.colors.text.secondary : _styles.colors.text.primary;
});
var Menu = exports.Menu = _styledComponents.default.div.withConfig({
  displayName: "Dropdownstyled__Menu",
  componentId: "sc-ms0xtq-2"
})(["position:absolute;display:flex;flex-direction:column;top:100%;left:0;min-width:100%;max-height:310px;margin-top:", ";", " border-radius:", ";padding:", " 0px;background:", ";opacity:", ";visibility:", ";pointer-events:", ";z-index:2;"], _styles.spacing.xs, _styles.shadow.m, _styles.borderRadius.s, _styles.spacing.xs, _styles.colors.background.primary, function (_ref11) {
  var expanded = _ref11.expanded;
  return expanded ? 1 : 0;
}, function (_ref12) {
  var expanded = _ref12.expanded;
  return expanded ? 'visible' : 'hidden';
}, function (_ref13) {
  var expanded = _ref13.expanded;
  return expanded ? 'all' : 'none';
});
var CurrentSelection = exports.CurrentSelection = _styledComponents.default.div.withConfig({
  displayName: "Dropdownstyled__CurrentSelection",
  componentId: "sc-ms0xtq-3"
})(["display:flex;align-items:center;", " gap:", ";"], function (_ref14) {
  var size = _ref14.size;
  return size ? _styles.fonts.atom[size] : _styles.font.base.regular;
}, _styles.spacing.xs);
var Option = exports.Option = (0, _styledComponents.default)(CurrentSelection).withConfig({
  displayName: "Dropdownstyled__Option",
  componentId: "sc-ms0xtq-4"
})(["justify-content:space-between;padding:", " ", ";", " &:hover{cursor:pointer;background-color:", ";}"], _styles.spacing.xs, _styles.spacing.m, function (_ref15) {
  var selected = _ref15.selected;
  return selected && _styles.font.base.bold;
}, _styles.colors.background.secondary.default);
var Color = exports.Color = _styledComponents.default.div.withConfig({
  displayName: "Dropdownstyled__Color",
  componentId: "sc-ms0xtq-5"
})(["flex-shrink:0;height:20px;width:20px;background-color:", ";border-radius:", ";"], function (_ref16) {
  var color = _ref16.color;
  return color;
}, _styles.borderRadius.s);
var DiagonalLine = exports.DiagonalLine = _styledComponents.default.div.withConfig({
  displayName: "Dropdownstyled__DiagonalLine",
  componentId: "sc-ms0xtq-6"
})(["flex-shrink:0;box-sizing:border-box;height:20px;width:20px;background:linear-gradient( to top left,rgba(0,0,0,0) 0%,rgba(0,0,0,0) calc(50% - 0.5px),", " 50%,rgba(0,0,0,0) calc(50% + 0.5px),rgba(0,0,0,0) 100% );border:1px solid ", ";border-radius:", ";"], _styles.colors.border.secondary, _styles.colors.border.secondary, _styles.borderRadius.s);
var DropdownButtonWrapper = exports.DropdownButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "Dropdownstyled__DropdownButtonWrapper",
  componentId: "sc-ms0xtq-7"
})(["height:", ";width:", ";position:relative;display:inline-flex;align-items:center;justify-content:center;gap:", ";box-sizing:border-box;cursor:pointer;border-radius:", ";visibility:", ";"], function (_ref17) {
  var visible = _ref17.visible;
  return visible ? '100%;' : '0px';
}, function (_ref18) {
  var visible = _ref18.visible;
  return visible ? '100%;' : '0px';
}, _styles.spacing.xs, _styles.borderRadius.s, function (_ref19) {
  var visible = _ref19.visible;
  return visible ? 'visible' : 'hidden';
});
var DropdownButtonContainer = exports.DropdownButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "Dropdownstyled__DropdownButtonContainer",
  componentId: "sc-ms0xtq-8"
})(["margin-top:2px;position:absolute;box-sizing:border-box;display:flex;flex-direction:column;align-items:stretch;background-color:", ";padding:", " 0px;gap:", ";", " border-radius:", ";z-index:100;visibility:", ";top:", ";left:", ";"], _styles.colors.background.primary, _styles.spacing.xs, _styles.spacing.xs, _styles.shadow.m, _styles.borderRadius.m, function (_ref20) {
  var visible = _ref20.visible;
  return visible ? 'visible' : 'hidden';
}, function (_ref21) {
  var bounds = _ref21.bounds;
  return bounds && bounds.bottom + 'px';
}, function (_ref22) {
  var bounds = _ref22.bounds;
  return bounds && bounds.left + 'px';
});